import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { Table } from '../../components';
import { useStore } from '../../core/utils/hook';
import { useLocation } from 'react-router-dom';

const StudentListByAttendanceCodeScreenWithListUser = observer(navigation  => {

    // params, query
    const { id } = useParams();
    const { state } = useLocation()

    // store
    const { groupAdminStore: { getDetailCompanyAttendanceRate, studentListWithAttCompany } } = useStore();

    // #17989 - the dashboard link only carries the bucket (lt50 / gte50 / eq100); the server
    // resolves and pages the learners of that bucket itself.
    const onFetch = (paging = {}) => {
        getDetailCompanyAttendanceRate(id, { bucket: state?.bucket, ...paging });
    };

    // lifecycle
    useEffect(() => {
        onFetch({ page: 1 });
    }, [id, state?.bucket])

    // columns table
    const columns = [
        {
            Header: '受講者名',
            accessor: 'name',
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        {original?.firstName + ' ' + original?.lastName}
                    </div>
                );
            },
            width: '10%'
        },
        {
            Header: 'メールアドレス',
            accessor: 'email',
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return (
                    <div>{original?.email}</div>
                );
            },
            width: '25%'
        },
        {
            Header: '薬剤師名簿登録番号',
            accessor: 'pharmacistNumber',
            disableSortBy: true,

            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        {original?.pharmacistNumber}
                    </div>
                );
            },
            width: '15%'
        },
        {
            Header: '受講期間',
            accessor: 'coursePeriodDate',
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        { original?.coursePeriodDate?.replace(/-/g, '/')}
                    </div>
                );
            },
            width: '30%'
        }
    ]

    return(
        <div id='main' className='wrapper main-student-list main-view-student-detail main-student-list'>
            <section className='content-student-list'>
                <div className='container'>
                    <h1 className='title-primary'>受講コード #{state?.attendanceCode} 別の受講者リスト</h1>
                    <Table
                        columns={columns}
                        data={studentListWithAttCompany?.elements || []}
                        enableServerSidePaging={true}
                        initialTableState={studentListWithAttCompany?.paginate}
                        onFetch={onFetch}
                        disablePaging={false}
                        disableSelectionPageSize={true}
                        showPagingInfo={false}
                        scrollHorizontalWidth={'768px'}
                        className='lst-attendance-table mg-t-35'
                    />
                </div>
            </section>
        </div>

    )
})

export default StudentListByAttendanceCodeScreenWithListUser;
